import { Injectable } from '@angular/core';
import { IPredmetStavkeFilterDto } from '@kodit/core/data-api';
import { AdvancedFilterActionData } from '@kodit/core/shared-ui';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UslugaFilterService {
  constructor() {}

  /**
   * Advanced filter methods
   */
  advanceFilterSubmitted$ = new BehaviorSubject<
    AdvancedFilterActionData<IPredmetStavkeFilterDto>
  >(null);
  get getAdvanceFilterSubmitted() {
    return this.advanceFilterSubmitted$.asObservable();
  }
  set setAdvanceFilterSubmitted(
    data: AdvancedFilterActionData<IPredmetStavkeFilterDto>
  ) {
    this.advanceFilterSubmitted$.next(data);
  }
}
